import requestPrint from "./print"

const _generateImage = (text, number) => {
    const _WIDTH = 200
    const _HEIGHT = 100

    const canvas = document.createElement('canvas')
    canvas.width = _WIDTH
    canvas.height = _HEIGHT

    const ctx = canvas.getContext('2d')
    ctx.beginPath()
    ctx.rect(0, 0, _WIDTH, _HEIGHT);
    ctx.fillStyle = 'white';
    ctx.fill();
    ctx.fillStyle = 'black';
    ctx.font = '70px Arial';

    ctx.fillText(text, 10, _HEIGHT - 40)

    ctx.fillStyle = 'black';
    ctx.font = '22px Arial';
    ctx.fillText(number, 10, _HEIGHT - 10);

    return canvas.toDataURL();
}

export default (text, number) => {
    const image = _generateImage(text, number)
    console.log(image)

    requestPrint(image)
}

